import { Controller } from "@hotwired/stimulus"

// Met à jour la date d'expiration quand on change la durée rapide
export default class extends Controller {
  static targets = ["endDate"]

  update() {
    const select = this.element.querySelector("select")
    const months = parseInt(select?.value, 10)
    if (!months || !this.hasEndDateTarget) return

    const now = new Date()
    const endDate = new Date(now.getFullYear(), now.getMonth() + months, now.getDate())
    const pad = (n) => String(n).padStart(2, "0")
    this.endDateTarget.value = `${endDate.getFullYear()}-${pad(endDate.getMonth() + 1)}-${pad(endDate.getDate())}`
  }
}
